<template>
    <transition name="submission--transition" mode="out-in">
        <div
            v-if="loading"
            class="submission__loading"
            :class="{ [`submission__loading--button submission__loading--button--${color} display--flex`]: haveSpecialClass }"
        >
            <span
                class="submission__loading__spinner"
                :class="`submission__loading__spinner--${color}`"
            ></span>
        </div>
        <div
            v-else-if="success"
            class="submission__response"
            :class="[
                { [`submission__loading--button submission__loading--button--${color} display--flex`]: haveSpecialClass },
                `submission__response--${color}`
            ]"
        >
            <svg class="submission__success" width="36" height="36" viewBox="0 0 36 36">
                <path class="path" d="M13.5 24.26L7.24 18l-2.12 2.12 8.38 8.38 18-18-2.12-2.12z" />
            </svg>
        </div>
        <slot v-else />
    </transition>
</template>

<script>
// package
import { reactive, ref, watch } from '@vue/composition-api';

// store
import { mapState } from '@/hooks/use-store';

export default {
    props: {
        haveSpecialClass: {
            type: Boolean,
            default: true
        },
        color: {
            type: String,
            default: 'blue'
        }
    },
    setup () {
        const loading = mapState({ module: 'storePayload', key: 'loading' });

        const store = reactive({
            response: mapState({ module: 'storePayload', key: 'response' })
        });

        const success = ref( false );

        // validação do tipo da resposta
        // proveninte da API.
        watch( () => store.response,
            newResponse => {
                success.value = ( newResponse.type ) ? newResponse.type === 'success' : false;
            });

        return { loading, success };
    }
};
</script>

<style lang="scss">
    // =============================================================================
    // Animations
    // =============================================================================
    @include keyframes ( spin ) {
        0% {
            @include transform( rotate( 0deg ) );
        }
        100% {
            @include transform( rotate( 360deg ) );
        }
    }

    @include keyframes ( slide-in-down ) {
        0% {
            @include transform( translateY( -20px ) );
            opacity: 0;
        }
        50% {
            opacity: .8;
        }
        100% {
            @include transform( translateY( 0 ) );
            opacity: 1;
        }
    }

    @include keyframes ( slide-out-down ) {
        0% {
            @include transform( translateY( 0 ) );
            opacity: 1;
        }
        40% {
            opacity: .2;
        }
        100% {
            @include transform( translateY( 20px ) );
            opacity: 0;
        }
    }

    // =============================================================================
    // Style
    // =============================================================================
    .submission {
        &--transition {
            &-leave-active {
                @include animation( slide-out-down 260ms cubic-bezier( .4, .0, 1, 1 ) );
            }
            &-enter-active  {
                @include animation( slide-in-down 260ms cubic-bezier( .0, .0, .2, 1 ) );
            }
        }
        &__loading {
            &--button {
                width: 241px;
                margin: 33px auto 0;
                align-items: center;
                justify-content: center;
                height: 50px;
                border: 1px solid;
                @include rounded-corner( 5px );
                &--blue {
                    border-color: $color-blue;
                }
                &--red {
                    border-color: $color-red;
                }
            }
            &__spinner {
                display: inline-block;
                vertical-align: middle;
                @include dimensions( 1.5em, 1.5em );
                border: .215em solid transparent;
                @include rounded-corner( 50% );
                margin: 0 8px;
                @include animation( spin 1s cubic-bezier( .55, .15, .45, .85 ) infinite );
                &--red {
                    border-top-color: $color-red;
                }
                &--white {
                    border-top-color: $color-white;
                }
                &--blue {
                    border-top-color: $color-blue;
                }
            }
        }
        &__response {
            &--blue {
                fill: $color-blue;
            }
            &--red {
                fill: $color-red;
            }
        }
    }
</style>